<template>
  <v-list class="py-0">
    <template v-for="item in getItems">
      <v-list-item :class="['px-0', { 'primary lighten-4': item.status === 'registered' }]" :key="item.id">
        <v-row>
          <v-col :class="['text-center text-truncate', { caption: $vuetify.breakpoint.mdAndDown }]">{{ item.date }}</v-col>
          <v-col :class="['text-right text-truncate', { caption: $vuetify.breakpoint.mdAndDown }]">{{ item.withdraw }}</v-col>
          <v-col :class="['text-right text-truncate', { caption: $vuetify.breakpoint.mdAndDown }]">{{ item.deposite }}</v-col>
          <v-col :class="['text-right text-truncate', { caption: $vuetify.breakpoint.mdAndDown }]">{{ item.balance }}</v-col>
          <v-col :class="['text-center text-truncate', { caption: $vuetify.breakpoint.mdAndDown }]">{{ item.client }}</v-col>
          <v-col :class="['text-center text-truncate', { caption: $vuetify.breakpoint.mdAndDown }]">{{ item.item }}</v-col>
        </v-row>
      </v-list-item>
      <v-divider :key="`${item.id}_div`"></v-divider>
    </template>
  </v-list>
</template>

<script>
export default {
  name: 'authorBbookPreviewMitsuisumitomo',
  props: [ 'items' ],
  computed: {
    getItems () {
      return (this.$props.items && this.$props.items.length) ? this.$props.items.map(it => {
        return {
          id: it.id,
          date: this.$moment(it.date).format('YYYY/MM/DD'),
          withdraw: `${it.withdraw}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'),
          deposite: `${it.deposite}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'),
          balance: `${it.balance}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'),
          client: it.client,
          item: it.item,
          status: it.status
        }
      }) : []
    }
  }
}
</script>